// extracted by mini-css-extract-plugin
export default {"copyButton":"d12b74a57686fe93","dropdownButton":"_79bb18e7cb67ca94","dropdownItem":"_7eaf0b9227d30f11"};